import classNames from 'classnames';
import React from 'react';

import styles from './Grid.module.scss';

export interface GridProps {
	wrap?: boolean;
	container?: boolean;
	nogutter?: boolean;
	center?: boolean;
	full?: boolean;
	children?: React.ReactNode;
}

export const Grid: React.FC<GridProps> = ({ wrap, container, nogutter, center, full, children }) => (
	<div
		className={classNames(
			styles.Grid,
			{ [styles.Grid___wrap]: wrap },
			{ [styles.Grid___container]: container },
			{ [styles.Grid___noGutter]: nogutter },
			{ [styles.Grid___center]: center },
			{ [styles.Grid___full]: full },
		)}
	>
		{children}
	</div>
);
